import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { ThemeProvider } from "./providers/theme.provider";
import LocalizationProvider from "./providers/localization.provider";
import Main from "./Main";

const App = () => {
  return (
    <LocalizationProvider>
      <ThemeProvider>
        <BrowserRouter>
          <Routes>
            <Route path="*" element={<Main />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </LocalizationProvider>
  );
};
export default App;
